import { TranslationError } from "shared/errors";

export class TranslationService {
  httpClient;
  baseUrl;

  constructor(baseUrl, apiClient) {
    this.httpClient = apiClient;
    this.baseUrl = baseUrl;
  }

  translateText = async (data) => {
    const url = `${this.baseUrl}/assessment/translate-text`;
    const response = await this.httpClient.post(url, data);
    // isSuccessful is only returned as false when an error has occurred
    if (response.isSuccessful === false) {
      throw new TranslationError();
    }
    return response.data;
  };
}
